import { render, staticRenderFns } from "./TeamRoster.vue?vue&type=template&id=a00c930a&"
import script from "./TeamRoster.vue?vue&type=script&lang=ts&"
export * from "./TeamRoster.vue?vue&type=script&lang=ts&"
import style0 from "./TeamRoster.vue?vue&type=style&index=0&id=a00c930a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports